import { BEND_CDN_ASSETS_LINK_BASE } from '../constants'
import { ThemeAssets } from './assets'
import { auroraAssets, auroraDarkModeAssets } from './auroraAssets'

const BEND_HOMEBASE_PATH = `${BEND_CDN_ASSETS_LINK_BASE}/homebase`
const BEND_CARE_NAVIGATOR_PATH = `${BEND_CDN_ASSETS_LINK_BASE}/careNavigator`

const bendAssetOverrides: ThemeAssets = {
  bendHomebaseSelfTriage: {
    assetNames: {
      defaultAsset: `${BEND_HOMEBASE_PATH}/selfTriage.png`,
      isMobileSized: `${BEND_HOMEBASE_PATH}/selfTriage-mobile.png`,
    },
  },
  bendHomebaseChildTriage: {
    assetNames: {
      defaultAsset: `${BEND_HOMEBASE_PATH}/childTriage.png`,
      isMobileSized: `${BEND_HOMEBASE_PATH}/childTriage-mobile.png`,
    },
  },
  bendCareNavigatorTriageZeroResult: {
    assetNames: {
      defaultAsset: `${BEND_CARE_NAVIGATOR_PATH}/triageZeroResult.png`,
    },
  },
}

export const bendAssets: ThemeAssets = {
  ...auroraAssets,
  ...bendAssetOverrides,
}

export const bendDarkModeAssets: ThemeAssets = {
  ...auroraDarkModeAssets,
  ...bendAssetOverrides,
}
